<template>
  <div>
    <!-- 留言展示框 -->
    <div class="msg-panel">
      <div class="msg-item" v-for="(msg, index) in pagedMessages" :key="index">
        <div class="msg-title">{{ msg.username }} 祝 {{ msg.teacher }}</div>
        <div class="msg-body">
          <span class="msg-content">{{ displayContent(msg) }}</span><span class="msg-toggle" v-if="needExpand(msg) || isExpanded(msg)" @click="toggleExpand(msg)">{{ isExpanded(msg) ? '收起▲' : '展开▼' }}</span>
          <span class="msg-date">{{ msg.regdate }}</span>
        </div>
      </div>

      <!-- 暂无留言 -->
      <div class="empty-tip" v-if="pagedMessages.length === 0">暂无留言</div>

      <!-- 隐藏探针：用于按"两行"实际渲染高度测量截断长度 -->
      <div class="msg-probe" ref="probe">
        <div class="msg-body"><span class="probe-text"></span><span class="msg-toggle">展开▼</span></div>
      </div>
    </div>

    <!-- 分页 -->
    <div class="pager">
      <img src="../assets/shouye/prev.png" alt="上一页" :class="{ disabled: currentPage === 1 }" @click="prevPage">
      <img src="../assets/shouye/next.png" alt="下一页" :class="{ disabled: currentPage === totalPages || pagedMessages.length === 0 }" @click="nextPage">
    </div>
  </div>
</template>

<script>
export default {
  name: 'SchoolMessageBoard',
  props: {
    messages: {
      type: Array,
      default: () => []
    },
    currentPage: {
      type: Number,
      default: 1
    },
    totalPages: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      expandedKeys: [],
      // 每条留言折叠状态下恰好占满两行的字符数
      fitLens: {}
    }
  },
  computed: {
    pagedMessages () {
      return this.messages
    }
  },
  watch: {
    messages () {
      this.expandedKeys = []
    },
    pagedMessages () {
      this.fitMessages()
    }
  },
  mounted () {
    this.fitMessages()
    window.addEventListener('resize', this.fitMessages)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.fitMessages)
  },
  methods: {
    msgKey (msg) {
      return this.messages.indexOf(msg)
    },
    isExpanded (msg) {
      return this.expandedKeys.indexOf(this.msgKey(msg)) > -1
    },
    toggleExpand (msg) {
      const key = this.msgKey(msg)
      const i = this.expandedKeys.indexOf(key)
      if (i > -1) {
        this.expandedKeys.splice(i, 1)
      } else {
        this.expandedKeys.push(key)
      }
    },
    needExpand (msg) {
      const n = this.fitLens[this.msgKey(msg)]
      return n != null && n < msg.content.length
    },
    displayContent (msg) {
      if (this.isExpanded(msg)) {
        return msg.content
      }
      const n = this.fitLens[this.msgKey(msg)]
      if (n == null || n >= msg.content.length) {
        return msg.content
      }
      return msg.content.slice(0, n) + '……'
    },
    // 在隐藏探针里二分查找：正文 + “……” + “展开▼” 恰好排满两行时的最长字符数
    fitMessages () {
      this.fitLens = {}
      this.$nextTick(() => {
        const probe = this.$refs.probe
        if (!probe) return
        const body = probe.querySelector('.msg-body')
        const textEl = probe.querySelector('.probe-text')
        const lineHeight = parseFloat(getComputedStyle(body).lineHeight)
        const maxH = lineHeight * 2 + 1
        this.pagedMessages.forEach(msg => {
          const full = msg.content
          let fit
          textEl.textContent = full
          if (body.scrollHeight <= maxH) {
            fit = full.length
          } else {
            let lo = 1
            let hi = full.length
            while (lo < hi) {
              const mid = (lo + hi + 1) >> 1
              textEl.textContent = full.slice(0, mid) + '……'
              if (body.scrollHeight <= maxH) {
                lo = mid
              } else {
                hi = mid - 1
              }
            }
            fit = lo
          }
          this.$set(this.fitLens, this.msgKey(msg), fit)
        })
        textEl.textContent = ''
      })
    },
    prevPage () {
      this.$emit('prev-page')
    },
    nextPage () {
      this.$emit('next-page')
    }
  }
}
</script>

<style scoped>
.msg-panel {
  position: relative;
  padding: 30px 0px 34px;
}

.msg-item {
  padding: 10px 4px 16px;
}

.empty-tip {
  text-align: center;
  padding: 20px 0;
  font-size: 15px;
  color: #75280c;
}

/* 测量探针：与 .msg-item 同宽同内边距，保证测量结果一致 */
.msg-probe {
  position: absolute;
  top: 0;
  left: 26px;
  right: 26px;
  padding: 0 4px;
  visibility: hidden;
  pointer-events: none;
}

.msg-title {
  font-size: 17px;
  font-weight: bold;
  color: #75280c;
  margin-bottom: 8px;
}

.msg-body {
  font-size: 15px;
  line-height: 1.9;
  color: #75280c;
}

.msg-toggle {
  margin-left: 6px;
  font-weight: bold;
  color: #75280c;
  cursor: pointer;
}

.msg-date {
  display: block;
  text-align: right;
  margin-top: 2px;
  font-size: 13px;
  color: #b5764a;
}

.pager {
  display: flex;
  justify-content: center;
  gap: 44px;
  margin: 22px 0 28px;
}

.pager img {
  width: 106px;
  cursor: pointer;
}

.pager img.disabled {
  opacity: 0.4;
  pointer-events: none;
}
</style>
